import React from 'react';
import { X, Check } from 'lucide-react';
const rows = [{
  situation: 'Organización',
  without: 'Caos',
  with: 'Claridad'
}, {
  situation: 'Emergencias',
  without: 'Improvisación',
  with: 'Preparación'
}, {
  situation: 'Recursos',
  without: 'Dependencia',
  with: 'Autonomía'
}, {
  situation: 'Hogar',
  without: 'Vulnerable',
  with: 'Más resiliente'
}, {
  situation: 'Tranquilidad',
  without: 'Baja',
  with: 'Mucho mayor'
}];
export function ComparisonTable() {
  return <section className="bg-transparent text-white py-5 px-5" data-id="element-61">
      <div className="max-w-xl mx-auto" data-id="element-62">
        <h2 className="text-2xl md:text-3xl font-bold text-center mb-8" data-id="element-63">
          La diferencia es clara
        </h2>

        <div className="bg-white/5 backdrop-blur-sm border border-white/10 rounded-xl overflow-hidden mb-10" data-id="element-64">
          <div className="grid grid-cols-3 text-center text-xs font-bold border-b border-white/10" data-id="element-65">
            <div className="p-3 text-gray-500" data-id="element-66">Situación</div>
            <div className="p-3 text-red-400 bg-red-950/20" data-id="element-67">Sin Sistema</div>
            <div className="p-3 text-green-400 bg-green-950/20" data-id="element-68">
              Con Hogar preparado™
            </div>
          </div>
          {rows.map((row, idx) => <div key={idx} className="grid grid-cols-3 text-center border-b border-gray-800/50 last:border-b-0" data-id="element-69">
              <div className="p-3 text-xs font-medium text-gray-400 flex items-center justify-center" data-id="element-70">
                {row.situation}
              </div>
              <div className="p-3 bg-red-950/10 flex flex-col items-center justify-center gap-1" data-id="element-71">
                <X size={16} className="text-red-500" data-id="element-72" />
                <span className="text-[11px] text-gray-500" data-id="element-73">{row.without}</span>
              </div>
              <div className="p-3 bg-green-950/10 flex flex-col items-center justify-center gap-1" data-id="element-74">
                <Check size={16} className="text-green-500" data-id="element-75" />
                <span className="text-[11px] text-white font-medium" data-id="element-76">
                  {row.with}
                </span>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}